function isCoBranded(documentServices) {
  return documentServices.account.isCoBranded()
}

export default {
  isCoBranded,
}
